import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "free",
  "use": "free-usage",
  "viewBox": "0 0 68 68",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 68\" id=\"free\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#A4A4AD\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M59.6 34v32H8.4V34M2 18h64v16H2zM34 66V18M34 18H19.6a8 8 0 1 1 0-16C30.8 2 34 18 34 18zm0 0h14.4a8 8 0 1 0 0-16C37.2 2 34 18 34 18z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol